import { render, staticRenderFns } from "./GameChat.vue?vue&type=template&id=e4c0a4f0&scoped=true&"
import script from "./GameChat.vue?vue&type=script&lang=js&"
export * from "./GameChat.vue?vue&type=script&lang=js&"
import style0 from "./GameChat.vue?vue&type=style&index=0&id=e4c0a4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c0a4f0",
  null
  
)

export default component.exports